import md5 from "md5";
// import axios from "axios";
// import { Message } from "element-ui";

/**
 * 文件相关工具
 */
export default class FileUtil {
  static fileClass = "common-input-file";

  static accept = {
    video: ["video/mp4"],
    image: ["image/png", "image/jpeg"],
    zip: [
      "application/zip",
      "application/x-zip",
      "application/x-zip-compressed",
    ],
    word: [
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/wps-writer",
    ],
  };

  /**
   * 获取视频时长
   */
  static getVideoDuration(url) {
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      video.preload = "metadata";

      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src);
        resolve(video.duration);
      };
      video.onerror = () => {
        reject();
      };

      video.src = url;
    });
  }

  /**
   * 获取音频时长
   */
  static getAudioDuration(url) {
    return new Promise((resolve, reject) => {
      const audio = new Audio();
      audio.oncanplay = () => {
        resolve(Math.floor(audio.duration));
      };
      audio.onerror = () => {
        reject();
      };
      audio.crossOrigin = "anonymous";
      audio.src = url;
      audio.load();
    });
  }

  // 获取file
  static getSelFiles({ multiple = false, accept = [] } = {}) {
    return new Promise((resolve) => {
      const id = this.getRandId();
      const input = document.createElement("input");

      input.setAttribute("id", id);
      input.setAttribute("type", "file");
      input.setAttribute("accept", accept.join(","));
      input.setAttribute("class", this.fileClass);
      input.setAttribute("style", "display: none");
      if (multiple) {
        input.setAttribute("multiple", "");
      }

      this.removeAllFileTag();
      document.body.appendChild(input);

      input.onchange = () => {
        let files = [];
        if (accept.length) {
          for (let file of input.files) {
            if (accept.indexOf(file.type) > -1) {
              files.push(file);
            }
          }
        } else {
          files = [...input.files];
        }
        if (multiple) {
          resolve(files);
        } else {
          resolve(files.length ? [files[0]] : []);
        }
        document.body.removeChild(input);
      };

      input.click();
    });
  }

  // 获取fileBase64
  static getBase64File(file, removeHead = false) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(
          removeHead
            ? reader.result.replace(/^data:image\/\w+;base64,/, "")
            : reader.result
        );
      };
    });
  }

  // 删除所有公用file
  static removeAllFileTag() {
    const els = document.querySelectorAll("." + this.fileClass);
    if (els) {
      for (let el of els) {
        document.body.removeChild(el);
      }
    }
  }

  // 获取随机id
  static getRandId() {
    return md5(new Date().getTime() + Math.random());
  }

  // 获取路径中的文件名（包含扩展名）
  static getPathFileName(path) {
    const temps = path.split("/");
    if (temps.length) {
      return temps[temps.length - 1];
    }
  }

  // 加载图片
  static loadImg(src) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        resolve(img);
      };
      img.onerror = () => {
        reject();
      };
      img.src = src;
    });
  }

  // 下载文件
  static download(uri, name = "") {
    const ext = this.getExtension(uri);
    if (name && name.indexOf(".") === -1) {
      name += "." + ext;
    }
    window.open(`${uri}?attname=` + name);
  }

  /**
   * 获取文件扩展名
   * @param name 文件名
   * @returns {string}
   */
  static getExtension(name) {
    if (name) {
      const temps = name.split(".");
      if (temps.length && temps.length > 1 && temps[temps.length - 1]) {
        return temps[temps.length - 1].toLowerCase();
      }
    }
  }

  /**
   * 查看文件 不支持就下载
   */
  static async seeFile(uri) {
    // const res = await axios.head(uri);
    // if (res.status !== 200) {
    //   Message.warning("文件信息获取失败");
    //   return;
    // }
    // const contentType = res.headers["content-type"];
    //
    // // Office
    // let fileTypes = [
    //   "application/msword", // .doc
    //   "application/wps-writer", // .doc
    //   "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    //   "application/vnd.ms-powerpoint", // .ppt
    //   "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
    //   "application/vnd.ms-excel", // .xls
    //   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" // .xlsx
    // ];
    // if (fileTypes.indexOf(contentType) > -1) {
    //   window.open(
    //     `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
    //       uri
    //     )}`
    //   );
    //   return;
    // }
    //
    // // Pdf
    // fileTypes = [
    //   "application/pdf" // .pdf
    // ];
    // if (fileTypes.indexOf(contentType) > -1) {
    //   window.open(uri);
    //   return;
    // }

    // 其它直接下载
    // console.log("不支持打开的文件类型", contentType);
    this.download(uri);
  }
}
